<template>
  <div class="daily-rate-editor__input">
    <hm-input-number v-model="currentEdit.value"
                     :autofocus="true"
                     :min-fraction-digits="fractionDigits"
                     :max-fraction-digits="fractionDigits"
                     :required="false"
                     class="table__cell__input number--right input__inline-editing"
                     inline
                     label="Amount"
                     @blur="completeInlineEditing"
    />
    <slot />
  </div>
</template>
<script>

import HmInputNumber from './HmInputNumber.vue';

export default {
  name: 'HmInputDailyRateEditor',
  components: { HmInputNumber },
  props: {
    completeInlineEditing: {},
    currentEdit: {},
    fractionDigits: {
      type: Number,
      default: 2,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputDailyRateEditor.vue